import React from 'react';
import { CogIcon, ScissorsIcon, ZapIcon, RulerIcon } from 'lucide-react';
export function ServicesSection() {
  const services = [{
    title: 'Motor Replacements',
    description: 'Expert replacement and repair for Somfy, Lutron, Crestron, Hunter Douglas, Rollease, and Vertilux motorized systems.',
    icon: CogIcon
  }, {
    title: 'Fabric Replacements',
    description: 'New fabric for exterior roller screens, exterior awnings, and interior roller shades. Wide selection of colors and transparency levels.',
    icon: ScissorsIcon
  }, {
    title: 'Low-Voltage Wiring',
    description: 'Low-voltage power panel wiring, troubleshooting, and shade reprogramming to keep your systems running flawlessly.',
    icon: ZapIcon
  }, {
    title: 'Design & Installation',
    description: 'Full-service tech measures, custom design consultation, and professional installation for any project.',
    icon: RulerIcon
  }];
  return <section id="services" className="bg-white py-16 md:py-28" data-id="element-162">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-163">
        <div className="text-center mb-10 sm:mb-16" data-id="element-164">
          <span className="block text-gold font-semibold tracking-widest text-sm uppercase mb-4" data-id="element-165">
            What We Do
          </span>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-charcoal" data-id="element-166">
            Our Services
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-8 max-w-5xl mx-auto" data-id="element-167">
          {services.map((service, index) => {
          const Icon = service.icon;
          return <div key={index} className="bg-white rounded-2xl p-6 sm:p-8 shadow-[0_4px_20px_-4px_rgba(0,0,0,0.05)] hover:shadow-[0_8px_30px_-4px_rgba(0,0,0,0.1)] hover:-translate-y-1 transition-all duration-300 border border-gray-100" data-id="element-168">
                <div className="w-14 h-14 bg-sand rounded-xl flex items-center justify-center mb-6" data-id="element-169">
                  <Icon className="w-7 h-7 text-gold" strokeWidth={1.5} data-id="element-170" />
                </div>
                <h3 className="text-xl font-bold text-charcoal mb-3" data-id="element-171">
                  {service.title}
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-172">
                  {service.description}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}